package com.eladfinish.bible.contest.screens.settings.ui.preferences

import androidx.compose.runtime.Composable
import com.eladfinish.bible.contest.LocalAppActions
import com.eladfinish.bible.contest.SharedRes
import com.eladfinish.bible.contest.common.settings.KeyValueSettings
import com.eladfinish.bible.contest.constants.Constants.PREF_LANGUAGE
import com.eladfinish.bible.contest.pref_language_title
import com.eladfinish.bible.contest.utils.applyLanguageChange
import dev.icerock.moko.resources.compose.stringResource
import kotlinx.collections.immutable.toImmutableList

@Composable
fun LanguagePreference(
    settings: KeyValueSettings,
) {
    val appActions = LocalAppActions.current

    val languages = linkedMapOf(
        "עברית" to "iw",
        "English" to "en",
        "Français" to "fr",
        "Español" to "es",
        "Deutsch" to "de",
        "Русский" to "ru",
    )

    DropdownPreference(
        title = stringResource(SharedRes.strings.pref_language_title),
        key = PREF_LANGUAGE,
        entries = languages.keys.toImmutableList(),
        entryValues = languages.values.toImmutableList(),
        onClick = { selectedCode ->
            applyLanguageChange(selectedCode)
            appActions.restartApp()
        },
        settings = settings,
    )
}
